// import { test } from './modules/test';
import { smooth } from './modules/smooth';
import { hamburger } from './modules/hamburger';
import { accordion } from './modules/accordion';
// test();
smooth();
hamburger();
accordion();
